import styled$1, { css } from 'styled-components';
import { color } from '@ccg/core';
import React$1 from 'react';
import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Modal$1 from 'react-modal';

const ModalAdapter = React$1.forwardRef((_ref, ref) => {
  let {
    className,
    modalClassName,
    children
  } = _ref,
      props = _objectWithoutProperties(_ref, ["className", "modalClassName", "children"]);

  return /*#__PURE__*/React$1.createElement(Modal$1, _extends({
    className: modalClassName,
    portalClassName: className,
    ref: ref
  }, props), children);
});
ModalAdapter.displayName = 'ModalAdapter';
ModalAdapter.propTypes = {
  className: PropTypes$1.string.isRequired,
  modalClassName: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.shape()]).isRequired,
  children: PropTypes$1.node.isRequired
};
const StyledModal = styled$1(ModalAdapter).attrs({
  overlayClassName: {
    base: 'modal__overlay',
    afterOpen: 'modal__overlay--after-open',
    beforeClose: 'modal__overlay--before-close'
  },
  modalClassName: {
    base: 'modal__content',
    afterOpen: 'modal__content--after-open',
    beforeClose: 'modal__content--before-close'
  }
})`
  .modal__overlay {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: auto;
    background: ${color('highlight01')};
  }

  .modal__content {
    position: relative;
    width: 100%;
    height: 100%;

    ${({
  flex
}) => flex && css(["display:flex;flex-direction:column;"])}
  }
`;

export default StyledModal;
